import WebStorage from "../lib/webStorage.js";
import Util from "./../lib/util.js";
import Logger from "./../lib/logger";
import geodesic from "./../lib/geodesic.js";
import PageLog from "./../lib/pageLog.js";
import { RepositoryFactory } from "./../repository/RepositoryFactory";
import { makeCancellable, takeLatest } from "vuex-cancellable-actions";

const MapGeojsonRepository = RepositoryFactory.get("MapGeojson");
const MapApiRepository = RepositoryFactory.get("MapApi");
const InfoJsonRepository = RepositoryFactory.get("infoJson");
const RiverWarnJsonRepository = RepositoryFactory.get("riverWarnJson");
const MapJsonRepository = RepositoryFactory.get("mapJsonRepository");

export default {
  namespaced: true,
  state: {
    /** 地図設定情報 */
    mapConfig: {},
    /** ズームレベル */
    zoom: undefined,
    /** ズームレベル最小値 */
    minZoom: undefined,
    /** ズームレベル最大値 */
    maxZoom: undefined,
    /** 地図表示範囲 */
    boundsArea: undefined,
    /** 地図中央位置 */
    center: [35.687088, 139.752844],
    /** 地図左下座標 */
    minCoord: [35.6586, 139.71667],
    /** 地図右上座標 */
    maxCoord: [35.69686, 139.79295],
    /** 現在位置座標 */
    currentLocation: [35.69686, 139.79295],
    /** 登録地点 */
    point: new Map(),
    /** 登録地点の周辺観測所情報 */
    aroundPointInfo: {
      knd: {
        stg: false,
        dam: false,
        scam: false,
        rn: false,
        qwtr: false,
        coast: false,
        snw: false,
        swstg: false,
      },
      tmInfo: {
        twnList: [],
        tmList: [],
      },
      swstgInfo: {
        twnList: [],
        swstgList: [],
      },
      scamInfo: {
        twnList: [],
        scamList: [],
      },
    },
    /** 地図タイル(淡色地図) */
    mapPaleUrl: undefined,
    /** 地図タイル(標高地図) */
    mapReliefUrl: undefined,
    /** 地図タイル(航空写真) */
    mapSeamlessphotoUrl: undefined,
    /** 地図タイル(白地図) */
    mapBlankUrl: undefined,
    /** 地図タイル(浸水想定) */
    mapInundationUrl: undefined,
    /** 地図タイル(河川) */
    mapRiverLineUrl: undefined,
    /** 地図タイル(浸水想定)表示設定 */
    showMapInundation: false,
    /** 表示都道府県一覧 */
    prefs: [],
    /** 表示市町村一覧 */
    towns: [],
    /** 都道府県 市町村種別 ['pref':都道府県, 'town':市町村] */
    prefTownType: "",
    /** ヘッダー表示都道府県名 */
    prefName: "",
    /** ヘッダー表示市区町村名 */
    townName: "",
    /** ヘッダー表示地方コード */
    areaCode: 0,
    /** ヘッダー表示都道府県コード */
    prefCode: 0,
    /** ヘッダー表示市町村コード */
    townCode: 0,
    /** 表示市町村取得時刻 */
    townsAcqTime: Util.toDate(),
    /** 表示グループ設定 */
    viewGroup: 0,
    /** 地図種別設定(0:淡色地図,1:淡色地図＋標高地図,2:航空写真,3:白地図) */
    mapType: 0,
    /** レーダ雨量表示設定 */
    viewRadar: false,
    /** 河川予警報表示設定 */
    viewRiverWarn: false,
    /** 河川表示設定 */
    viewRiver: false,
    /** 登録地点表示設定 */
    viewPoint: false,
    /** 表示コンテンツ設定 */
    viewContents: 0,
    /** 住所検索ダイアログ表示 */
    showAreaSearch: false,
    /** 日付入力ダイアログ表示 */
    showCalendar: false,
    /** 表示グループ設定ダイアログ表示 */
    showViewGroup: false,
    /** 地図凡例ダイアログ表示 */
    showLegend: false,
    /** トースト表示 */
    showToast: false,
    /** 選択観測所グループトースト表示 */
    showTmGroupToast: false,
    /** トースト表示メッセージ */
    toastMessage: undefined,
    /** お知らせ情報ダイアログ表示 */
    showInformation: false,
    /** 緊急お知らせダイアログ表示 */
    showEmergencyInfoDlg: false,
    /** 任意お知らせダイアログ表示 */
    showAnyInfoDlg: false,
    /** 河川予警報情報ダイアログ表示 */
    showRiverWarnInfo: false,
    /** お知らせ情報 */
    information: [
      {
        /** お知らせ管理番号 */
        infoManageCd: undefined,
        /** お知らせ種別番号 */
        infoKindCd: undefined,
        /** 分類 */
        summaryCd: undefined,
        /** 発表日時 */
        date: undefined,
        /** タイトル */
        summary: undefined,
        /** 地方(都道府県名) */
        prefecturesNm: undefined,
        /** 対象 */
        target: undefined,
        /** 本文 */
        detail: undefined,
        /** CCTV URL */
        cctvUrl: undefined,
        /** 観測所 URL */
        obsUrl: undefined,
      },
    ],
    /** 河川予警報情報 */
    riverWarnInfo: [
      {
        /** ID */
        id: undefined,
        /** 予警報の種類 */
        type: undefined,
        /** 種別コード */
        knd: undefined,
        /** 種別名 */
        kndNm: undefined,
        /** 区間コード */
        code: undefined,
        /** 区間名 */
        name: undefined,
        /** 見出し */
        heading: undefined,
        /** 発令時刻 */
        annTime: undefined,
        /** 号数 */
        annNo: undefined,
      },
    ],
    /** お知らせ情報 */
    tmInfo: {},
    /** 河川予警報情報 */
    tmRwInfo: {},
    /** 河川予警報情報の数 */
    tmRwInfoLength: 0,
    /** モバイルメニュー表示 */
    showMbSideMenu: true,
    /** 住所検索結果 */
    addressSearchResultsInfo: {},
    /** 住所検索状態 [1:検索前 2:検索中 3:検索後] */
    addressSearchStatus: 1,
    /** 現在位置情報取得フラグ */
    currentLocationFlag: false,
    /** 現在位置情報取得エラーフラグ */
    currentLocationErrorFlag: false,
    /** 表示範囲の河川GeoJson */
    riverGeoJson: [],
    /** 予警報の関連市町村Polygon */
    townPolygon: [],
    /** 登録地編集モード [0:未編集, 1:地図選択, 2:登録確認] */
    editLocationMode: 0,
    /** webストレージ編集日時 */
    editWebStorageDate: "",
    /** 登録地点選択情報 */
    editLocation: {},
    /** 周辺観測所編集モード [0:未編集, 1:地図選択, 2:登録確認] */
    editTmMode: 0,
    /** 周辺観測所選択 */
    editTm: {},
    // 市町村判定・座標リスト
    townLatLngList: [],
    // 都道府県別市町村座標リスト
    latLngListByPref: [],
    // 都道府県判定リスト
    prefJudgeList: [],
    /** 重複表示観測所一覧表示 */
    showTmList: false,
    /** 重複表示観測所一覧 */
    overlapTmList: [],
    /** 履歴動画準備状態 ['ready':準備状態, 'playable':再生可状態] */
    historyPlayPrepStatus: "playable",
    /** 検索回数 */
    searchNum: 0,
    /** 選択登録地点 */
    selectPointIndex: undefined,
    /** 登録地点の選択浸水想定河川 */
    selectPointRiver: [],
    /** 地図選択中観測所 */
    selectTm: null,
    /** 地図選択中予警報 */
    selectRw: null,
    /** 登録中フラグ */
    editFlag: 0,
    /** 地図移動アニメーション情報 */
    flyToInfo: {
      zoom: null,
      center: null,
    },
    /** 地図移動情報 */
    moveInfo: {
      zoom: null,
      center: null,
    },
    /** 中心移動フラグ */
    shiftCenterFlg: false,
    /** 予警報選択時移動フラグ */
    selectRwMoveFlg: false,
    /** 予警報選択時表示範囲 */
    selectRwRange: {
      nLat: null,
      eLon: null,
      sLat: null,
      wLon: null,
    },
    /** 地図再描画のためのコンポーネントのKey */
    mapComponentKey: 0,
    /** 現在位置登録エラーフラグ */
    registCurrentLocationErrorFlag: false,
    /** 現在位置登録フラグ */
    registCurrentLocationFlag: false,
    // 中心市町村
    centerTownTarget: [],
    // 表示中心市町村
    dispCenterTwon: "",
  },
  mutations: {
    /** 初期化 */
    init(
      state,
      {
        zoom,
        center,
        minZoom,
        maxZoom,
        boundsArea,
        mapType,
        viewGroup,
        viewRadar,
        viewRiverWarn,
        viewRiver,
        viewPoint,
        viewContents,
      }
    ) {
      Logger.debug(
        "[map]mut - init(" +
          zoom +
          "," +
          center +
          "," +
          minZoom +
          "," +
          maxZoom +
          "," +
          boundsArea +
          "," +
          mapType +
          "," +
          viewGroup +
          "," +
          viewRadar +
          "," +
          viewRiverWarn +
          "," +
          viewRiver +
          "," +
          viewPoint +
          "," +
          viewContents +
          ")"
      );
      state.zoom = zoom;
      state.center = center;
      state.minZoom = minZoom;
      state.maxZoom = maxZoom;
      state.boundsArea = boundsArea;
      state.mapType = mapType;
      state.viewGroup = viewGroup;
      state.viewRadar = viewRadar;
      state.viewRiverWarn = viewRiverWarn;
      state.viewRiver = viewRiver;
      state.viewContents = viewContents;
      // 簡易版では河川表示しない
      if (global.KWB_MODE == "reduction") {
        state.viewRiver = false;
      }
      state.viewPoint = viewPoint;
      state.mapPaleUrl = state.mapConfig.url.mainMap;
      state.mapReliefUrl = state.mapConfig.url.reliefMap;
      state.mapSeamlessphotoUrl = state.mapConfig.url.seamlessphotoMap;
      state.mapBlankUrl = state.mapConfig.url.blankMap;
      state.mapRiverLineUrl = state.mapConfig.url.riverLine;
    },
    /** 登録中フラグ */
    setEditFlag(state, flag) {
      Logger.debug("[ViewConfig]mut - setEditFlag(" + flag + ")");
      state.editFlag = flag;
    },
    /** 設定情報を設定 */
    setMapConfig(state, mapConfig) {
      Logger.debug("[map]mut - setMapConfig(mapConfig)");
      Logger.dir(mapConfig);
      state.mapConfig = mapConfig;
    },
    /** 地図種別設定 */
    setMapType(state, Type) {
      Logger.debug("[map]mut - setMapType(" + Type + ")");
      state.mapType = Type;
    },
    /** 表示グループ設定 */
    setViewGroup(state, group) {
      Logger.debug("[map]mut - setViewGroup(" + group + ")");
      state.viewGroup = group;
    },
    /** レーダ雨量表示設定 */
    setViewRadar(state, radar) {
      Logger.debug("[map]mut - setViewRadar(" + radar + ")");
      state.viewRadar = radar;
    },
    /** 河川予警報表示設定 */
    setViewRiverWarn(state, warn) {
      Logger.debug("[map]mut - setViewRiverWarn(" + warn + ")");
      state.viewRiverWarn = warn;
    },
    /** 河川表示設定 */
    setViewRiver(state, river) {
      Logger.debug("[map]mut - setViewRiver(" + river + ")");
      state.viewRiver = river;
    },
    /** 登録地点表示設定 */
    setViewPoint(state, point) {
      Logger.debug("[map]mut - setViewPoint(" + point + ")");
      state.viewPoint = point;
    },
    /** 表示コンテンツ設定 */
    setViewContents(state, contents) {
      Logger.debug("[map]mut - setViewContents(" + contents + ")");
      state.viewContents = contents;
    },
    /** 住所検索ダイアログ表示切替 */
    setShowAreaSearch(state, status) {
      Logger.debug("[map]mut - setShowAreaSearch(" + status + ")");
      state.showAreaSearch = status;
      if (status) {
        state.showViewGroup = false;
        state.showCalendar = false;
        state.showEmergencyInfoDlg = false;
      }
    },
    /** 日付入力ダイアログ表示切替 */
    setShowCalendar(state, status) {
      Logger.debug("[map]mut - setShowCalendar(" + status + ")");
      state.showCalendar = status;
      if (status) {
        state.showViewGroup = false;
        state.showAreaSearch = false;
        state.showEmergencyInfoDlg = false;
      }
    },
    /** 表示グループ設定ダイアログ表示切替 */
    setShowViewGroup(state, status) {
      Logger.debug("[map]mut - setShowViewGroup(" + status + ")");
      state.showViewGroup = status;
      if (status) {
        state.showCalendar = false;
        state.showAreaSearch = false;
        state.showEmergencyInfoDlg = false;
      }
    },
    /** 地図凡例ダイアログ表示切替 */
    setShowLegend(state, status) {
      Logger.debug("[map]mut - setShowLegend(" + status + ")");
      state.showLegend = status;
    },
    /** トースト表示切替 */
    setShowToast(state, { status, message }) {
      Logger.debug("[map]mut - setShowToast(" + status + "," + message + ")");
      state.showToast = status;
      if (status) {
        state.toastMessage = message;
      }
    },
    /** 選択観測所グループトースト表示切替 */
    setShowTmGroupToast(state, status) {
      Logger.debug("[map]mut - setShowTmGroupToast(" + status + ")");
      state.showTmGroupToast = status;
    },
    /** お知らせダイアログ表示 */
    showInformation(state) {
      Logger.debug("[map]mut - showInformation()");
      state.showRiverWarnInfo = false;
      state.showInformation = true;
    },
    /** お知らせ情報 */
    setInformation(state, info) {
      Logger.debug("[map]mut - setTmInfo(info)");
      Logger.dir(info);
      state.information = info;
    },
    /** 緊急度が一番高いお知らせ情報 */
    setTmInfo(state, info) {
      Logger.debug("[map]mut - setTmInfo(info)");
      Logger.dir(info);
      state.tmInfo = info;
    },
    /** 緊急お知らせダイアログ表示切替 */
    setShowEmergencyInfoDlg(state, status) {
      Logger.debug("[map]mut - setShowEmergencyInfoDlg(" + status + ")");
      state.showEmergencyInfoDlg = status;
      if (status) {
        state.showViewGroup = false;
        state.showCalendar = false;
        state.showAreaSearch = false;
      }
    },
    /** 任意お知らせダイアログ表示切替 */
    setShowAnyInfoDlg(state, status) {
      Logger.debug("[map]mut - setShowAnyInfoDlg(" + status + ")");
      state.showAnyInfoDlg = status;
    },
    /** 河川予警報ダイアログ表示 */
    showRiverWarnInfo(state, info) {
      Logger.debug("[map]mut - showRiverWarnInfo(info)");
      Logger.dir(info);
      state.showInformation = false;
      state.showRiverWarnInfo = true;
      state.riverWarnInfo = info;
    },
    /** 河川予警報情報 */
    setTmRwInfo(state, info) {
      Logger.debug("[map]mut - setTmRwInfo(info)");
      Logger.dir(info);
      state.tmRwInfo = info;
    },
    /** 河川予警報情報の数 */
    setTmRwInfoLength(state, length) {
      Logger.debug("[map]mut - setTmRwInfoLength(length)");
      Logger.dir(length);
      state.tmRwInfoLength = length;
    },
    /** お知らせ・河川予警報ダイアログ非表示 */
    hideInfoRw(state) {
      Logger.debug("[map]mut - hideInfoRw()");
      state.showInformation = false;
      state.showRiverWarnInfo = false;
      state.riverWarnInfo = undefined;
    },
    /** モバイルメニュー表示切替 */
    toggleShowMbSideMenu(state) {
      Logger.debug("[map]mut - toggleShowMbSideMenu()");
      state.showMbSideMenu = !state.showMbSideMenu;
    },
    /**ズームレベル設定 */
    setViewZoom(state, zoom) {
      Logger.debug("[map]mut - setViewZoom(" + zoom + ")");
      /** ズームレベルの設定値が適切な場合にのみ処理を実行する */
      if (zoom >= state.minZoom && zoom <= state.maxZoom) {
        state.zoom = Math.ceil(zoom);
      }
    },
    /** 地図中央位置設定 */
    setCenter(state, LatLng) {
      Logger.debug("[map]mut - setCenter(" + LatLng + ")");
      /** 座標が変更された場合にのみ処理を実行する */
      if (state.center[0] != LatLng[0] || state.center[1] != LatLng[1]) {
        state.center = LatLng;
      }
    },
    /** 地図右上座標と左下座標設定 */
    setCoord(state, latLngBounds) {
      Logger.debug("[map]mut - setCoord(latLngBounds)");
      Logger.dir(latLngBounds);
      /** 座標が変更された場合にのみ処理を実行する */
      if (
        state.maxCoord[0] != latLngBounds._northEast.lat ||
        state.maxCoord[1] != latLngBounds._northEast.lng
      ) {
        state.maxCoord = [
          latLngBounds._northEast.lat,
          latLngBounds._northEast.lng,
        ];
      }
      if (
        state.minCoord[0] != latLngBounds._southWest.lat ||
        state.minCoord[1] != latLngBounds._southWest.lng
      ) {
        state.minCoord = [
          latLngBounds._southWest.lat,
          latLngBounds._southWest.lng,
        ];
      }
    },
    /** 住所検索結果を更新する */
    setAddressSearchResultsInfo(state, searchResults) {
      Logger.debug("[map]mut - setAddressSearchResultsInfo(searchResults)");
      Logger.dir(searchResults);
      state.addressSearchResultsInfo = searchResults;
    },
    /** 現在位置情報取得エラーフラグを更新する */
    setCurrentLocationErrorFlag(state, status) {
      Logger.debug("[map]mut - setCurrentLocationErrorFlag(" + status + ")");
      state.currentLocationErrorFlag = status;
    },
    /** 住所検索状態を更新する */
    setAddressSearchStatus(state, status) {
      Logger.debug("[map]mut - setAddressSearchStatus(" + status + ")");
      state.addressSearchStatus = status;
    },
    /** 現在位置座標を更新する */
    updateLc(state, currentLatLng) {
      Logger.debug("[map]mut - updateLc(" + currentLatLng + ")");
      state.currentLocation = currentLatLng;
    },
    /** 現在位置情報取得フラグ切替 */
    toggleSwitchCurrentLocationFlag(state) {
      Logger.debug("[map]mut - toggleSwitchCurrentLocationFlag()");
      state.currentLocationFlag = !state.currentLocationFlag;
    },
    /** 表示範囲の河川GeoJson設定 */
    setRiverLocation(state, riverLines) {
      Logger.debug("[map]mut - setRiverLocation(riverLines)");
      Logger.dir(riverLines);
      state.riverGeoJson = riverLines;
    },
    /** 予警報の関連市町村Polygon設定 */
    setTownPolygon(state, townPolygons) {
      Logger.debug("[map]mut - setTownPolygon(townPolygons)");
      Logger.dir(townPolygons);
      state.townPolygon = townPolygons;
    },
    /** 登録地編集モード */
    setEditLocationMode(state, editLocationMode) {
      Logger.debug("[map]mut - setEditLocationMode(" + editLocationMode + ")");
      state.editLocationMode = editLocationMode;
    },
    /** webストレージ編集日時 */
    setEditWebStorageDate(state, editWebStorageDate) {
      Logger.debug(
        "[map]mut - setEditWebStorageDate(" + editWebStorageDate + ")"
      );
      state.editWebStorageDate = editWebStorageDate;
    },
    /** 登録地点選択情報 */
    setEditLocation(state, LocationInfo) {
      Logger.debug("[map]mut - setEditLocation(LocationInfo)");
      Logger.dir(LocationInfo);
      state.editLocation = LocationInfo;
    },
    /** 周辺観測所編集モード */
    setEditTmMode(state, editTmMode) {
      Logger.debug("[map]mut - setEditTmMode(" + editTmMode + ")");
      state.editTmMode = editTmMode;
    },
    /** 周辺観測所選択 */
    setEditTm(state, editTm) {
      Logger.debug("[map]mut - setEditTm(editTm)");
      Logger.dir(editTm);
      state.editTm = editTm;
    },
    /** 登録地点の情報を設定する */
    setPointInfo(state, pointInfo) {
      Logger.debug("[map]mut - setPointInfo(pointInfo)");
      Logger.dir(pointInfo);
      state.point = pointInfo;
    },
    /** 登録地点の周辺観測所情報を設定 */
    setAroundPointInfo(state, aroundPointInfo) {
      Logger.debug("[map]mut - setAroundPointInfo(aroundPointInfo)");
      Logger.dir(aroundPointInfo);
      state.aroundPointInfo = aroundPointInfo;
    },
    /** 市町村座標リストを更新 */
    setTownLatLngList(state, townLatLngList) {
      Logger.debug("[map]mut - setTownLatLngList(townLatLngList)");
      Logger.dir(townLatLngList);
      state.townLatLngList = townLatLngList;

      // 都道府県別リスト作成
      let latLngListByPref = [];
      townLatLngList.forEach((tInfo) => {
        // 都道府県が存在するか確認
        let prefInfo = latLngListByPref.find(
          (pInfo) => pInfo.prefCd == tInfo.prefCd
        );
        // 存在する場合はリストに追加
        if (prefInfo) {
          prefInfo.twnList.push({
            lat: tInfo.lat,
            lon: tInfo.lon,
            prefCd: tInfo.prefCd,
            prefNm: tInfo.prefNm,
            twnCd: tInfo.twnCd,
            twnNm: tInfo.twnNm,
            maxLat: tInfo.maxLat,
            maxLon: tInfo.maxLon,
            minLat: tInfo.minLat,
            minLon: tInfo.minLon,
          });
        } else {
          // 存在しない場合は新たにリストを作成
          latLngListByPref.push({
            prefCd: tInfo.prefCd,
            twnList: [
              {
                lat: tInfo.lat,
                lon: tInfo.lon,
                prefCd: tInfo.prefCd,
                prefNm: tInfo.prefNm,
                twnCd: tInfo.twnCd,
                twnNm: tInfo.twnNm,
                maxLat: tInfo.maxLat,
                maxLon: tInfo.maxLon,
                minLat: tInfo.minLat,
                minLon: tInfo.minLon,
              },
            ],
          });
        }
      });
      state.latLngListByPref = latLngListByPref;
      Logger.debug("[map]mut - latLngListByPref set");
      Logger.dir(state.latLngListByPref);
    },
    /** 都道府県判定リストを更新 */
    setPrefJudgeList(state, prefJudgeList) {
      Logger.debug("[map]mut - setPrefJudgeList(prefJudgeList)");
      Logger.dir(prefJudgeList);
      state.prefJudgeList = prefJudgeList;
    },
    /** 表示都道府県・表示市町村を更新 */
    setPrefsTowns(state, { prefs, towns }) {
      Logger.debug("[map]mut - setPrefsTowns(prefs,towns)");
      Logger.dir(prefs);
      Logger.dir(towns);

      let updateTownsAcqTime = false;
      // 表示市町村取得時刻の更新判定
      if (state.zoom < state.mapConfig.zoomReferenceTowns) {
        if (state.prefTownType != "pref") {
          updateTownsAcqTime = true;
          state.prefTownType = "pref";
        } else if (state.prefs.length != prefs.length) {
          updateTownsAcqTime = true;
        } else {
          // 内容の確認(順番が違えば更新と判断する)
          for (let cnt = 0; cnt < state.prefs.length; cnt++) {
            if (state.prefs[cnt].id != prefs[cnt].id) {
              updateTownsAcqTime = true;
              break;
            }
          }
        }
      } else {
        if (state.prefTownType != "town") {
          updateTownsAcqTime = true;
          state.prefTownType = "town";
        } else if (state.towns.length != towns.length) {
          updateTownsAcqTime = true;
        } else {
          // 内容の確認(順番が違えば更新と判断する)
          for (let cnt = 0; cnt < state.towns.length; cnt++) {
            if (state.towns[cnt].id != towns[cnt].id) {
              updateTownsAcqTime = true;
              break;
            }
          }
        }
      }
      state.prefs = prefs;
      state.towns = towns;
      if (updateTownsAcqTime) {
        state.townsAcqTime = Util.toDate();
      }
      Logger.debug("[map]mut - prefTownType:" + state.prefTownType);
    },
    /** 重複表示観測所一覧表示を更新 */
    setShowTmList(state, flg) {
      Logger.debug("[map]mut - setShowTmList(" + flg + ")");
      state.showTmList = flg;
    },
    /** 重複表示観測所一覧を更新 */
    setOverlapTmList(state, overlapTmList) {
      Logger.debug("[map]mut - setOverlapTmList(overlapTmList)");
      Logger.dir(overlapTmList);
      state.overlapTmList = overlapTmList;
    },
    /** 地図タイル(浸水想定)表示設定とURLを更新 */
    setMapInundation(state, { flg, inundationId }) {
      Logger.debug(
        "[map]mut - setMapInundation(" + flg + "," + inundationId + ")"
      );
      state.showMapInundation = flg;
      // 洪水浸水想定区域IDからURLを設定
      state.mapInundationUrl =
        state.mapConfig.url.inundation.root +
        inundationId +
        state.mapConfig.url.inundation.end;
    },
    /** ヘッダー表示都道府県,市町村名設定 */
    setTownName(state, { prefName, townName, areaName, areaCd, zoom }) {
      Logger.debug(
        "[map]mut - setTownName(" +
          prefName +
          "," +
          townName +
          "," +
          areaName +
          "," +
          areaCd +
          "," +
          zoom +
          ")"
      );
      if (zoom < state.mapConfig.zoomRegion) {
        // 全国
        state.prefName = state.mapConfig.nationwideName;
        state.townName = "";
        state.areaCode = state.mapConfig.nationwideCode;
      } else if (zoom < state.mapConfig.zoomPrefecture) {
        // 地方
        state.prefName = areaName;
        state.townName = "";
        state.areaCode = areaCd;
      } else if (zoom < state.mapConfig.zoomCity) {
        // 都道府県
        state.prefName = prefName;
        state.townName = "";
        state.areaCode = areaCd;
      } else {
        // 市区町村
        state.prefName = prefName;
        state.townName = townName;
        state.areaCode = areaCd;
      }
    },
    /** 履歴動画準備状態 */
    setHistoryPlayPrepStatus(state, prepStatus) {
      Logger.debug("[map]mut - setHistoryPlayPrepStatus(" + prepStatus + ")");
      state.historyPlayPrepStatus = prepStatus;
    },
    /** 検索回数加算 */
    incrementSearchNum(state) {
      Logger.debug("[map]mut - incrementSearchNum()");
      state.searchNum++;
    },
    /** 選択登録地点更新 */
    setSelectPointIndex(state, index) {
      Logger.debug("[map]mut - setSelectPointIndex(" + index + ")");
      state.selectPointIndex = index;
    },
    /** 登録地点の選択浸水想定河川更新 */
    setSelectPointRiver(state, riverList) {
      Logger.debug("[map]mut - setSelectPointRiver(riverList)");
      Logger.dir(riverList);
      state.selectPointRiver = riverList;
    },
    /** 地図上のダイアログを全て閉じる */
    dialogAllClose(state) {
      state.showAreaSearch = false;
      state.showCalendar = false;
      state.showViewGroup = false;
      state.showLegend = false;
      state.showEmergencyInfoDlg = false;
      state.showAnyInfoDlg = false;
      state.showTmList = false;
      state.showInformation = false;
      state.showRiverWarnInfo = false;
      state.showEmergencyInfoDlg = false;
    },
    /** 地図選択中観測所を設定 */
    setSelectTm(state, selectTmInfo) {
      Logger.debug("[map]mut - setSelectTm(selectTmInfo)");
      Logger.dir(selectTmInfo);
      state.selectTm = selectTmInfo;
    },
    /** 地図選択中予警報を設定 */
    setSelectRw(state, selecRwInfo) {
      Logger.debug("[map]mut - setSelectRw(selecRwInfo)");
      Logger.dir(selecRwInfo);
      state.selectRw = selecRwInfo;
    },
    /** 地図移動アニメーション情報を設定 */
    setFlyToInfo(state, flyToInfo) {
      Logger.debug("[map]mut - setFlyToInfo(flyToInfo)");
      Logger.dir(flyToInfo);
      state.flyToInfo = flyToInfo;
    },
    /** 地図移動情報を設定 */
    setMoveInfo(state, moveInfo) {
      Logger.debug("[map]mut - setMoveInfo(moveInfo)");
      Logger.dir(moveInfo);
      state.moveInfo = moveInfo;
    },
    /** 中心移動フラグを設定 */
    setShiftCenterFlg(state, flg) {
      Logger.debug("[map]mut - setShiftCenterFlg(" + flg + ")");
      state.shiftCenterFlg = flg;
    },
    /** 予警報選択時移動フラグを設定 */
    setSelectRwMoveFlg(state, { flg, nLat, eLon, sLat, wLon }) {
      Logger.debug(
        "[map]mut - setSelectRwMoveFlg(" +
          flg +
          "," +
          nLat +
          "," +
          eLon +
          "," +
          sLat +
          "," +
          wLon +
          ")"
      );
      state.selectRwMoveFlg = flg;
      state.selectRwRange = {
        nLat: nLat,
        eLon: eLon,
        sLat: sLat,
        wLon: wLon,
      };
    },
    /** 地図再描画のためコンポーネントKeyを更新 */
    mapRedraw(state) {
      Logger.debug("[map]mut - mapRedraw()");
      ++state.mapComponentKey;
    },
    /** 現在位置登録エラーフラグを設定 */
    setRegistCurrentLocationErrorFlag(state, status) {
      Logger.debug(
        "[map]mut - setRegistCurrentLocationErrorFlag(" + status + ")"
      );
      state.RegistCurrentLocationErrorFlag = status;
    },
    /** 現在位置登録フラグを設定 */
    setRegistCurrentLocationFlag(state, status) {
      Logger.debug("[map]mut - setRegistCurrentLocationFlag(" + status + ")");
      state.registCurrentLocationFlag = status;
    },
    /** 中心市町村設定 */
    setCenterTownTarget(state, centerTownTarget) {
      Logger.debug("[map]mut - setCenterTownTarget(centerTownTarget)");
      state.centerTownTarget = centerTownTarget;
    },
    /** 表示中心市町村設定 */
    setDispCenterTwon(state, dispCenterTwon) {
      Logger.debug("[map]mut - setDispCenterTwon(" + dispCenterTwon + ")");
      state.dispCenterTwon = dispCenterTwon;
    },
  },
  actions: makeCancellable({
    /** 現在位置を取得し、移動する */
    moveCurrentLocation(context, mode) {
      Logger.debug("[map]act - moveCurrentLocation(" + mode + ")");
      context.commit("setCurrentLocationErrorFlag", false);
      if (context.state.currentLocationFlag == false) {
        // 現在位置未取得の場合、現在位置を取得する
        navigator.geolocation.getCurrentPosition(
          /** 現在位置取得成功時の処理 */
          function (position) {
            // 取得した現在位置情報を保持する
            let currentLatLng = [
              position.coords.latitude,
              position.coords.longitude,
            ];
            // ストア上の現在位置座標と地図中心位置を更新する
            context.commit("updateLc", currentLatLng);
            context.commit("setFlyToInfo", {
              zoom: context.state.mapConfig.zoomLocation,
              center: currentLatLng,
            });
            // 現在位置情報取得フラグの設定を取得済状態にする
            context.commit("toggleSwitchCurrentLocationFlag");
            if (mode == "pc") {
              // 住所検索を閉じる
              context.commit("setShowAreaSearch", false);
            }
          },
          /** 現在位置取得エラー時の処理 */
          function () {
            context.commit("setCurrentLocationErrorFlag", true);
          }
        );
      } else {
        // 現在位置取得済の場合、現在位置情報取得フラグの設定を未取得状態にする
        context.commit("toggleSwitchCurrentLocationFlag");
        if (mode == "pc") {
          // 住所検索を閉じる
          context.commit("setShowAreaSearch", false);
        }
      }
    },
    /** 登録地点の情報を取得する */
    getRegistrationPointInfo(context) {
      Logger.debug("[map]act - getRegistrationPointInfo()");
      let pointMap = new Map();

      let Point1Info = WebStorage.getPoint1Info();
      if (Point1Info) {
        pointMap.set(1, Point1Info);
      }

      let Point2Info = WebStorage.getPoint2Info();
      if (Point2Info) {
        pointMap.set(2, Point2Info);
      }

      let Point3Info = WebStorage.getPoint3Info();
      if (Point3Info) {
        pointMap.set(3, Point3Info);
      }

      let Point4Info = WebStorage.getPoint4Info();
      if (Point4Info) {
        pointMap.set(4, Point4Info);
      }

      let Point5Info = WebStorage.getPoint5Info();
      if (Point5Info) {
        pointMap.set(5, Point5Info);
      }

      context.commit("setPointInfo", pointMap);

      // 市町村と周辺観測所のリストを抽出
      let tmTwnList = [];
      let swstgTwnList = [];
      let scamTwnList = [];
      let tmList = [];
      let swstgList = [];
      let scamList = [];
      let knd = {
        stg: false,
        dam: false,
        scam: false,
        rn: false,
        qwtr: false,
        coast: false,
        snw: false,
        swstg: false,
      };
      pointMap.forEach((pointObj) => {
        // 観測所情報
        if (pointObj.tmDatas.tmPoint) {
          pointObj.tmDatas.tmPoint.forEach((tm) => {
            // 観測所種別
            if (tm.itmkndCd == 4) {
              knd.stg = true;
            } else if (
              tm.itmkndCd == 1 ||
              tm.itmkndCd == 2 ||
              tm.itmkndCd == 20 ||
              tm.itmkndCd == 21
            ) {
              knd.rn = true;
            } else if (tm.itmkndCd == 6) {
              knd.qwtr = true;
            } else if (tm.itmkndCd == 7) {
              knd.dam = true;
            } else if (tm.itmkndCd == 12) {
              knd.coast = true;
            } else if (tm.itmkndCd == 3) {
              knd.snw = true;
            } else if (tm.itmkndCd == 300) {
              knd.swstg = true;
            }
            // 市町村
            if (!tmTwnList.some((obj) => obj.id == tm.twnCd)) {
              tmTwnList.push({ id: tm.twnCd });
            }
            // 伝送記号
            let obsFcd =
              ("0000" + tm.ofcCd).slice(-5) +
              ("00" + tm.itmkndCd).slice(-3) +
              ("0000" + tm.obsCd).slice(-5);
            if (!tmList.includes(obsFcd)) {
              tmList.push(obsFcd);
            }
          });
        }
        // 危機管理型水位情報
        if (pointObj.tmDatas.swPoint) {
          pointObj.tmDatas.swPoint.forEach((swstg) => {
            // 観測所種別
            knd.swstg = true;
            // 市町村
            if (!swstgTwnList.some((obj) => obj.id == swstg.twnCd)) {
              swstgTwnList.push({
                id: swstg.twnCd,
              });
            }
            // 危機管理型水位計番号
            if (!swstgList.includes(swstg.swobsCd)) {
              swstgList.push(swstg.swobsCd);
            }
          });
        }
        // カメラ情報
        if (pointObj.tmDatas.scamPoint) {
          pointObj.tmDatas.scamPoint.forEach((scam) => {
            // 観測所種別
            knd.scam = true;
            // 市町村
            if (!scamTwnList.some((obj) => obj.id == scam.twnCd)) {
              scamTwnList.push({
                id: scam.twnCd,
              });
            }
            // カメラID
            if (!scamList.includes(Number(scam.scamId))) {
              scamList.push(Number(scam.scamId));
            }
          });
        }
      });
      context.commit("setAroundPointInfo", {
        knd: knd,
        tmInfo: {
          twnList: tmTwnList,
          tmList: tmList,
        },
        swstgInfo: {
          twnList: swstgTwnList,
          swstgList: swstgList,
        },
        scamInfo: {
          twnList: scamTwnList,
          scamList: scamList,
        },
      });
    },
    /**
     * 河川GeoJson取得
     * @param {*} param0
     * @param towns 市町村リスト
     */
    getRiverGeoJson: takeLatest(async function (
      { commit, state },
      prefTwnList
    ) {
      Logger.debug("[map]act - getRiverGeoJson(prefTwnList)");
      Logger.dir(prefTwnList);
      let riverLines = [];
      // 市町村コードの数だけ処理を繰り返す
      for (let count = 0; count < prefTwnList.length; count++) {
        // 市町村別河川情報ファイルを取得
        Logger.debug("[map]API - getRiverInfo(" + prefTwnList[count].id + ")");
        const { data: riverInfo, error: riverInfoError } =
          await MapJsonRepository.getRiverInfo(prefTwnList[count].id);
        Logger.debug(
          "[map]API - getRiverInfo(" + prefTwnList[count].id + ") - return"
        );
        Logger.dir(riverInfo);
        Logger.dir(riverInfoError);

        if (!riverInfoError) {
          for (
            var riversCount = 0;
            riversCount < riverInfo.rivers.length;
            riversCount++
          ) {
            // 8桁になるよう先頭ゼロ埋め
            const fileName = (
              "0000000" + riverInfo.rivers[riversCount].rvrCd
            ).slice(-8);
            // 既に取得済みの河川は処理を行わない
            if (riverLines.find((geoJson) => geoJson.rvrCd == fileName)) {
              continue;
            }
            // 既にストアに保持している河川GeoJsonは再利用する
            let beforeRiverObj = state.riverGeoJson.find(
              (geoJson) => geoJson.rvrCd == fileName
            );
            if (beforeRiverObj) {
              riverLines.push(beforeRiverObj);
              continue;
            }

            // ストアに保持していない場合、河川Geojsonを取得
            Logger.debug("[map]API - getRiver(" + fileName + ")");
            const { data, error } = await MapGeojsonRepository.getRiver(
              fileName
            );
            Logger.debug("[map]API - getRiver(" + fileName + ") - return");
            Logger.dir(data);
            Logger.dir(error);

            if (!error && data) {
              data.rvrCd = fileName;
              riverLines.push(data);
            }
          }
        }
      }
      // 取得情報をストアに格納
      commit("setRiverLocation", riverLines);
    }),
    /**
     * 市町村Polygon取得
     * @param {*} param0
     * @param towns 市町村リスト
     */
    getTownPolygon: takeLatest(async function ({ commit }, towns) {
      Logger.debug("[map]act - getTownPolygon(towns)");
      Logger.dir(towns);
      let townPolygons = [];
      // 市町村の数だけAPIからデータ取得
      for (var i = 0; i < towns.length; i++) {
        // 7桁になるよう先頭ゼロ埋め
        const fileName = ("000000" + towns[i]).slice(-7);
        Logger.debug("[map]API - getTown(" + fileName + ")");
        const { data, error } = await MapGeojsonRepository.getTown(fileName);
        Logger.debug("[map]API - getTown(" + fileName + ") - return");
        Logger.dir(data);
        Logger.dir(error);
        if (!error) {
          townPolygons.push(data);
        }
      }
      // 取得情報をストアに格納
      commit("setTownPolygon", townPolygons);
    }),
    /** 観測所選択
     * @param latLng 中心位置
     */
    moveMapTm: takeLatest(async function (
      { commit, state },
      { latLng, tmZoom }
    ) {
      Logger.debug("[map]act - moveMapTm(" + latLng + "," + tmZoom + ")");
      // 地図移動後に中心をずらす
      commit("setShiftCenterFlg", true);
      // 地図ズームレベルと選択観測所の最低表示ズームレベルを比較し、より大きいレベルに変更する
      if (state.zoom < tmZoom) {
        commit("setFlyToInfo", {
          zoom: tmZoom,
          center: latLng,
        });
      } else {
        commit("setFlyToInfo", {
          zoom: state.zoom,
          center: latLng,
        });
      }
    }),
    /** 予警報選択
     * @param type 予警報種別
     * @param latLng 中心位置
     * @param nLat 北端緯度
     * @param eLon 東端経度
     * @param sLat 南端緯度
     * @param wLon 西端経度
     */
    moveMapRw: takeLatest(async function (
      { commit, state },
      { type, latLng, nLat, eLon, sLat, wLon }
    ) {
      Logger.debug(
        "[map]act - moveMapRw(" +
          type +
          "," +
          latLng +
          "," +
          nLat +
          "," +
          eLon +
          "," +
          sLat +
          "," +
          wLon +
          ")"
      );
      // 地図移動後に中心をずらす
      commit("setShiftCenterFlg", true);

      // ズームレベル調整のための予警報選択時移動フラグを有効にする
      commit("setSelectRwMoveFlg", {
        flg: true,
        nLat: nLat,
        eLon: eLon,
        sLat: sLat,
        wLon: wLon,
      });

      // 種別に合わせてズームレベルを設定
      let zoomLevel = 0;
      if (type === 10) zoomLevel = state.mapConfig.zoomSelectEvstgs;
      else if (type === 11) zoomLevel = state.mapConfig.zoomSelectFldfrs;
      else if (type === 20) zoomLevel = state.mapConfig.zoomSelectFldctls;
      else if (type === 30) zoomLevel = state.mapConfig.zoomSelectDamdsch;

      commit("setFlyToInfo", {
        zoom: zoomLevel,
        center: latLng,
      });
    }),
    /** 概況図(全国)選択 */
    moveMapNationwide({ commit, state }) {
      Logger.debug("[map]act - moveMapNationwide()");
      commit("setFlyToInfo", {
        zoom: state.mapConfig.zoomNationwide,
        center: state.mapConfig.nationwideLatLng,
      });
    },
    /** 概況図(地方)選択
     * @param areaCd エリアコード
     */
    moveMapRegion: takeLatest(async function ({ commit, state }, areaCd) {
      Logger.debug("[map]act - moveMapRegion(" + areaCd + ")");
      const target = state.mapConfig.regionLatLngList.find((regionInfo) => {
        return regionInfo.areaCd == areaCd;
      });

      if (target) {
        commit("setFlyToInfo", {
          zoom: state.mapConfig.zoomRegion,
          center: target.center,
        });
      }
    }),
    /** 概況図(都道府県)選択
     * @param prefCd 都道府県コード
     */
    moveMapPrefecture: takeLatest(async function ({ commit, state }, prefCd) {
      Logger.debug("[map]act - moveMapPrefecture(" + prefCd + ")");
      const target = state.mapConfig.prefLatLngList.find((prefInfo) => {
        return prefInfo.prefCd == prefCd;
      });

      if (target) {
        // 地図移動後に中心をずらす
        commit("setShiftCenterFlg", true);
        commit("setFlyToInfo", {
          zoom: state.mapConfig.zoomPrefecture,
          center: target.center,
        });
      }
    }),
    /** 対象市町村選択
     * @param twnCd 市町村コード(7桁)
     */
    moveMapCity: takeLatest(async function ({ commit, state }, twnCd) {
      Logger.debug("[map]act - moveMapCity(" + twnCd + ")");
      const target = state.townLatLngList.find((townInfo) => {
        return townInfo.twnCd == twnCd;
      });

      if (target) {
        // 地図移動後に中心をずらす
        commit("setShiftCenterFlg", true);
        commit("setFlyToInfo", {
          zoom: state.mapConfig.zoomCity,
          center: [target.lat, target.lon],
        });
      }
    }),
    /** 登録地点選択
     * @param latLng 中心位置
     */
    moveMapPoint: takeLatest(async function (
      { commit, state },
      { latLng, flyto }
    ) {
      Logger.debug("[map]act - moveMapPoint(" + latLng + "," + flyto + ")");
      // 地図移動後に中心をずらす
      commit("setShiftCenterFlg", flyto);
      // 現在のズームレベルが規定値以上の場合は変更しない
      if (state.zoom < state.mapConfig.zoomPoint) {
        if (flyto) {
          commit("setFlyToInfo", {
            zoom: state.mapConfig.zoomPoint,
            center: latLng,
          });
        } else {
          commit("setMoveInfo", {
            zoom: state.mapConfig.zoomPoint,
            center: latLng,
          });
        }
      } else {
        if (flyto) {
          commit("setFlyToInfo", { zoom: state.zoom, center: latLng });
        } else {
          commit("setMoveInfo", { zoom: state.zoom, center: latLng });
        }
      }
    }),
    /** 現在地選択
     * @param latLng 中心位置
     */
    moveMapLocation: takeLatest(async function ({ commit, state }, latLng) {
      Logger.debug("[map]act - moveMapLocation(" + latLng + ")");
      // 現在のズームレベルが規定値以上の場合は変更しない
      if (state.zoom < state.mapConfig.zoomLocation) {
        commit("setFlyToInfo", {
          zoom: state.mapConfig.zoomLocation,
          center: latLng,
        });
      } else {
        commit("setFlyToInfo", { zoom: state.zoom, center: latLng });
      }
    }),
    /** 都道府県判定リスト、市町村判定リストを取得 */
    async getPrefTownJadgeList({ commit }) {
      Logger.debug("[map]act - getPrefTownJadgeList()");
      // 都道府県判定リスト
      // ファイルからデータ取得
      Logger.debug("[map]API - getPrefList()");
      const { data: prefData, prefError } =
        await MapJsonRepository.getPrefList();
      Logger.debug("[map]API - getPrefList() - return");
      Logger.dir(prefData);
      Logger.dir(prefError);
      if (!prefError) {
        // 取得情報をストアに格納
        commit("setPrefJudgeList", prefData.prefs);
      }
      // 市町村判定リスト
      // ファイルからデータ取得
      Logger.debug("[map]API - getTownList()");
      const { data: townData, townError } =
        await MapJsonRepository.getTownList();
      Logger.debug("[map]API - getTownList() - return");
      Logger.dir(townData);
      Logger.dir(townError);
      if (!townError) {
        // 取得情報をストアに格納
        commit("setTownLatLngList", townData.towns);
      }
    },
    /**
     * 表示市町村取得
     */
    async getTowns({ commit, state }) {
      Logger.debug("[map]act - getTowns()");

      let prefs = [];
      let towns = [];

      // 都道府県
      state.prefJudgeList.forEach((pref) => {
        // 取得範囲内の都道府県に絞る
        let pushFlg = true;
        // 小数点計算の誤差を無くすため10*9倍にして計算する
        if (
          pref.maxLat * Math.pow(10, 9) <
          state.minCoord[0] * Math.pow(10, 9)
        ) {
          pushFlg = false;
        } else if (
          pref.maxLon * Math.pow(10, 9) <
          state.minCoord[1] * Math.pow(10, 9)
        ) {
          pushFlg = false;
        } else if (
          pref.minLat * Math.pow(10, 9) >
          state.maxCoord[0] * Math.pow(10, 9)
        ) {
          pushFlg = false;
        } else if (
          pref.minLon * Math.pow(10, 9) >
          state.maxCoord[1] * Math.pow(10, 9)
        ) {
          pushFlg = false;
        }
        if (pushFlg) {
          prefs.push({ id: pref.prefCd, name: pref.prefNm });
        }
      });

      // 市町村
      // 市町村単位のデータを参照するズームレベルの場合のみ実施
      if (
        state.zoom >= state.mapConfig.zoomReferenceTmTowns ||
        state.zoom >= state.mapConfig.zoomTmCctv ||
        state.zoom >= state.mapConfig.zoomTmScam ||
        state.zoom >= state.mapConfig.zoomReferenceTowns
      ) {
        state.townLatLngList.forEach((town) => {
          // 取得範囲内の市町村に絞る
          let pushFlg = true;
          if (
            town.maxLat * Math.pow(10, 9) <
            state.minCoord[0] * Math.pow(10, 9)
          ) {
            pushFlg = false;
          } else if (
            town.maxLon * Math.pow(10, 9) <
            state.minCoord[1] * Math.pow(10, 9)
          ) {
            pushFlg = false;
          } else if (
            town.minLat * Math.pow(10, 9) >
            state.maxCoord[0] * Math.pow(10, 9)
          ) {
            pushFlg = false;
          } else if (
            town.minLon * Math.pow(10, 9) >
            state.maxCoord[1] * Math.pow(10, 9)
          ) {
            pushFlg = false;
          }
          if (pushFlg) {
            towns.push({
              id: town.twnCd,
              name: town.twnNm,
              prefName: town.prefNm,
            });
          }
        });
      }

      // 取得情報をストアに格納
      commit("setPrefsTowns", {
        prefs: prefs,
        towns: towns,
      });
    },
    /** 住所検索結果取得
     * @param {*} searchWord 検索ワード
     */
    getAddressSearchResults: takeLatest(async function (
      { commit, state },
      { searchWord, deviceSb, fcFlg }
    ) {
      Logger.debug("[map]act - getAddressSearchResults(" + searchWord + ")");
      let addressSearchResults = {};

      // 現在の検索回数を保持しておく
      const currentSearchNum = state.searchNum;

      // 住所検索状態を「検索中」にする
      commit("setAddressSearchStatus", 2);

      // APIから市町村名検索結果を取得
      Logger.debug("[map]API - getAreaSearchResults(" + searchWord + ")");
      const { data } = await MapApiRepository.getAreaSearchResults(searchWord);
      Logger.debug(
        "[map]API - getAreaSearchResults(" + searchWord + ") - return"
      );
      Logger.dir(data);
      // 検索中かつ検索回数が変化していない場合のみ、結果を保存する
      if (
        state.addressSearchStatus === 2 &&
        currentSearchNum === state.searchNum
      ) {
        addressSearchResults.cityNameSearchResults = data.result.cityNameSearch;
        addressSearchResults.postalCodeSearchResults = data.result.postCdSearch;
        addressSearchResults.areaCordSearchResults = data.result.telSearch;
        // 取得情報をストアに格納
        commit("setAddressSearchResultsInfo", addressSearchResults);
        // 住所検索状態を「検索後」にする
        commit("setAddressSearchStatus", 3);
        // アクセスログ出力
        // 該当なしフラグ設定
        let noHit = 0;
        if (
          data.result.cityNameSearch.length == 0 &&
          data.result.postCdSearch.length == 0 &&
          data.result.telSearch.length == 0
        ) {
          noHit = 1;
        }
        PageLog.log({
          page_log: "map_search",
          device_sb: deviceSb,
          fc_flg: fcFlg,
          kw: searchWord,
          no_hit: noHit,
        });
      }
    }),
    /**
     * 個別観測所画面用お知らせ情報を取得
     * @param {*} ofcCd 管理事務所番号
     * @param {*} itmkndCd 観測所種別コード
     * @param {*} obsCd 観測所コード
     */
    getObsInformation: takeLatest(async function (
      { commit },
      { ofcCd, itmkndCd, obsCd }
    ) {
      Logger.debug(
        "[map]act - getObsInformation(" +
          ofcCd +
          "," +
          itmkndCd +
          "," +
          obsCd +
          ")"
      );
      let tmInfo = [];
      let tmInfoFirst = [];

      // 伝送記号の生成
      const obsFcd =
        ("0000" + ofcCd).slice(-5) +
        ("00" + itmkndCd).slice(-3) +
        ("0000" + obsCd).slice(-5);

      // APIからデータ取得
      Logger.debug("[map]API - getObsInformation()");
      const { data, error } = await InfoJsonRepository.getObsInformation(
        obsFcd
      );
      Logger.debug("[map]API - getObsInformation() - return");
      Logger.dir(data);
      Logger.dir(error);

      if (!error && data !== "") {
        // 対象観測所のお知らせがあるか検索
        const target = data.tm.find(
          (tmObj) => tmObj.obsrvtnPointFullCode == obsFcd
        );
        if (target) {
          // すべてのお知らせ情報
          tmInfo = target.info;
          // 緊急度が一番高い１レコードを抽出
          let lvlFirst = null;
          target.info.forEach((infoObj) => {
            if (
              !lvlFirst ||
              Util.getInfoLvl(lvlFirst.summaryCode) <
                Util.getInfoLvl(infoObj.summaryCode)
            ) {
              lvlFirst = infoObj;
            }
          });
          if (lvlFirst) {
            tmInfoFirst.push(lvlFirst);
          }
        }
      }
      // すべてのお知らせ情報を格納
      commit("setInformation", tmInfo);
      // 緊急度が一番高い１レコードを格納
      commit("setTmInfo", tmInfoFirst);
    }),
    /**
     * カメラ観測所画面用お知らせ情報を取得
     * @param {*} scamId 簡易カメラID
     */
    getObsScamInformation: takeLatest(async function ({ commit }, { scamId }) {
      Logger.debug("[map]act - getObsScamInformation(" + scamId + ")");
      let tmInfo = [];
      let tmInfoFirst = [];

      // APIからデータ取得
      Logger.debug("[map]API - getObsInformation()");
      const { data, error } = await InfoJsonRepository.getScamInformation(
        scamId
      );
      Logger.debug("[map]API - getObsInformation() - return");
      Logger.dir(data);
      Logger.dir(error);

      if (!error && data !== "") {
        // 対象カメラのお知らせがあるか検索
        const target = data.camera.find((tmObj) => tmObj.scamId == scamId);
        if (target) {
          // すべてのお知らせ情報
          tmInfo = target.info;

          // 緊急度が一番高い１レコードを抽出
          let lvlFirst = null;
          target.info.forEach((infoObj) => {
            if (
              !lvlFirst ||
              Util.getInfoLvl(lvlFirst.summaryCode) <
                Util.getInfoLvl(infoObj.summaryCode)
            ) {
              lvlFirst = infoObj;
            }
          });
          if (lvlFirst) {
            tmInfoFirst.push(lvlFirst);
          }
        }
      }

      // すべてのお知らせ情報を格納
      commit("setInformation", tmInfo);
      // 緊急度が一番高い１レコードを格納
      commit("setTmInfo", tmInfoFirst);
    }),
    /**
     * 個別観測所画面用 河川予警報情報を取得
     * @param {*} ofcCd 管理事務所番号
     * @param {*} itmkndCd 観測所種別コード
     * @param {*} obsCd 観測所コード
     * @param {*} isFldCtl 水防団モード
     * @param {*} appTime 対象日時
     */
    getObsRiverWarnInfo: takeLatest(async function (
      { commit },
      { ofcCd, itmkndCd, obsCd, isFldCtl, appTime }
    ) {
      Logger.debug(
        "[map]act - getObsRiverWarnInfo(" +
          ofcCd +
          "," +
          itmkndCd +
          "," +
          obsCd +
          "," +
          isFldCtl +
          "," +
          appTime +
          ")"
      );
      let rwInfo = [];

      // 伝送記号の生成
      const obsFcd =
        ("0000" + ofcCd).slice(-5) +
        ("00" + itmkndCd).slice(-3) +
        ("0000" + obsCd).slice(-5);
      // APIからデータ取得
      Logger.debug(
        "[map]API - getObsRiverWarnInfo(" + obsFcd + "," + appTime + ")"
      );
      const { data, error } = await RiverWarnJsonRepository.getObsRiverWarnInfo(
        obsFcd,
        appTime
      );
      Logger.debug(
        "[map]API - getObsRiverWarnInfo(" +
          obsFcd +
          "," +
          appTime +
          ") - return"
      );
      Logger.dir(data);
      Logger.dir(error);

      if (!error) {
        rwInfo = data.rw;
        if (!isFldCtl) {
          // 水防団モードではない場合、水防警報を除く
          rwInfo = rwInfo.filter((info) => info.type !== "fldctl");
        }
      }
      commit("showRiverWarnInfo", rwInfo);
    }),
    /**
     * 個別観測所画面用 河川予警報情報の中で緊急度が一番高い１レコードのみ取得
     * @param {*} ofcCd 管理事務所番号
     * @param {*} itmkndCd 観測所種別コード
     * @param {*} obsCd 観測所コード
     * @param {*} isFldCtl 水防団モード
     * @param {*} appTime 対象日時
     */
    getObsRwInfo: takeLatest(async function (
      { commit },
      { ofcCd, itmkndCd, obsCd, isFldCtl, appTime }
    ) {
      Logger.debug(
        "[map]act - getObsRwInfo(" +
          ofcCd +
          "," +
          itmkndCd +
          "," +
          obsCd +
          "," +
          isFldCtl +
          "," +
          appTime +
          ")"
      );
      let rwInfo = [];

      // 伝送記号の生成
      const obsFcd =
        ("0000" + ofcCd).slice(-5) +
        ("00" + itmkndCd).slice(-3) +
        ("0000" + obsCd).slice(-5);
      // APIからデータ取得
      Logger.debug(
        "[map]API - getObsRiverWarnInfo(" + obsFcd + "," + appTime + ")"
      );
      const { data, error } = await RiverWarnJsonRepository.getObsRiverWarnInfo(
        obsFcd,
        appTime
      );
      Logger.debug(
        "[map]API - getObsRiverWarnInfo(" +
          obsFcd +
          "," +
          appTime +
          ") - return"
      );
      Logger.dir(data);
      Logger.dir(error);

      if (!error) {
        if (!isFldCtl) {
          // 水防団モードではない場合、水防警報を除く
          data.rw = data.rw.filter((info) => info.type !== "fldctl");
        }
        // 危険度が一番高い１レコードのみ抽出
        let lvlFirst = null;
        data.rw.forEach((rwObj) => {
          if (!lvlFirst || lvlFirst.lvl < rwObj.lvl) {
            lvlFirst = rwObj;
          }
        });

        if (lvlFirst) {
          rwInfo.push(lvlFirst);
        }
      }

      commit("setTmRwInfo", rwInfo);
      commit("setTmRwInfoLength", !error ? data.rw.length : 0);
    }),
    /**
     * 個別観測所画面用 河川予警報情報と河川予警報情報の中で緊急度が一番高い１レコードを取得
     * @param {*} ofcCd 管理事務所番号
     * @param {*} itmkndCd 観測所種別コード
     * @param {*} obsCd 観測所コード
     * @param {*} isFldCtl 水防団モード
     * @param {*} appTime 対象日時
     */
    getObsRiverWarnRwInfo: takeLatest(async function (
      { commit },
      { ofcCd, itmkndCd, obsCd, isFldCtl, appTime }
    ) {
      Logger.debug(
        ofcCd +
          "," +
          itmkndCd +
          "," +
          obsCd +
          "," +
          isFldCtl +
          "," +
          appTime +
          ")"
      );
      let rwInfo = [];

      // 伝送記号の生成
      const obsFcd =
        ("0000" + ofcCd).slice(-5) +
        ("00" + itmkndCd).slice(-3) +
        ("0000" + obsCd).slice(-5);
      // APIからデータ取得
      Logger.debug(
        "[map]API - getObsRiverWarnRwInfo(" + obsFcd + "," + appTime + ")"
      );
      const { data, error } = await RiverWarnJsonRepository.getObsRiverWarnInfo(
        obsFcd,
        appTime
      );
      Logger.debug(
        "[map]API - getObsRiverWarnRwInfo(" +
          obsFcd +
          "," +
          appTime +
          ") - return"
      );
      Logger.dir(data);
      Logger.dir(error);

      if (!error) {
        if (!isFldCtl) {
          // 水防団モードではない場合、水防警報を除く
          data.rw = data.rw.filter((info) => info.type !== "fldctl");
        }
        // 危険度が一番高い１レコードのみ抽出
        let lvlFirst = null;
        data.rw.forEach((rwObj) => {
          if (!lvlFirst || lvlFirst.lvl < rwObj.lvl) {
            lvlFirst = rwObj;
          }
        });
        commit("showRiverWarnInfo", data.rw);

        if (lvlFirst) {
          rwInfo.push(lvlFirst);
        }
      }

      commit("setTmRwInfo", rwInfo);
      commit("setTmRwInfoLength", !error ? data.rw.length : 0);
    }),
    /**
     * 現在位置登録
     */
    registCurrentLocation: takeLatest(async function ({ commit, state }) {
      Logger.debug("[map]act - registCurrentLocation({*},{})");
      // 現在位置未取得の場合、現在位置を取得する
      navigator.geolocation.getCurrentPosition(
        /** 現在位置取得成功時の処理 */
        function (position) {
          // 取得した現在位置情報を保持する
          let currentLatLng = [
            position.coords.latitude,
            position.coords.longitude,
          ];
          // ストア上の現在位置座標と地図中心位置を更新する
          commit("updateLc", currentLatLng);
          // 地図移動アニメーション情報を設定
          commit("setFlyToInfo", {
            zoom: state.mapConfig.zoomPoint,
            center: currentLatLng,
          });

          // 登録地点選択情報
          commit("setEditLocation", {
            zoom: state.zoom,
            latlng: currentLatLng,
          });

          // 現在位置登録エラーフラグの設定をfalseにする。
          commit("setRegistCurrentLocationErrorFlag", false);
          // 現在位置登録フラグの設定をtrueにする。
          commit("setRegistCurrentLocationFlag", true);
        },
        // 現在位置取得エラー時の処理
        function () {
          commit("setRegistCurrentLocationErrorFlag", true);
          commit("setRegistCurrentLocationFlag", false);
        }
      );
    }),
    /**
     * 中心市町村名を取得
     */
    getCenterTown: takeLatest(async function (
      { commit, state },
      { center, twnList }
    ) {
      Logger.debug("[map]act - getCenterTown({*},{twnList})");
      let targetList = [];

      // 対象の市町村の、大字緯度経度を取得
      for (let twn of twnList) {
        let isTarget = true;
        // 前回取得済みの場合は再利用
        for (let target of state.centerTownTarget) {
          if (twn.id === target.id) {
            targetList.push({
              id: target.id,
              prefName: target.prefName,
              townName: target.townName,
              towns: target.towns,
            });
            isTarget = false;
            break;
          }
        }
        if (isTarget) {
          const { data: twnPosInfo, error: twnPosError } =
            await MapJsonRepository.getTwnPos(twn.id);
          if (!twnPosError) {
            targetList.push({
              id: twn.id,
              prefName: twn.prefName,
              townName: twn.name,
              towns: twnPosInfo.towns,
            });
          }
        }
      }

      let distanceDiff = -1;
      let prefNm = "";
      let townNm = "";

      // 最も近い大字の市町村を採用する
      for (let target of targetList) {
        for (let town of target.towns) {
          let targetDiff = geodesic.getDistance(center, [town.lat, town.lon]);
          if (distanceDiff < 0 || distanceDiff > targetDiff) {
            distanceDiff = targetDiff;
            prefNm = target.prefName;
            townNm = target.townName;
          }
        }
      }

      // 中心市町村設定
      commit("setCenterTownTarget", targetList);
      // 表示中心市町村設定
      commit("setDispCenterTwon", prefNm + townNm);
    }),
  }),
};
